import { render, staticRenderFns } from "./viewProject.vue?vue&type=template&id=1df221c1&scoped=true"
import script from "./viewProject.vue?vue&type=script&lang=js"
export * from "./viewProject.vue?vue&type=script&lang=js"
import style0 from "./viewProject.vue?vue&type=style&index=0&id=1df221c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df221c1",
  null
  
)

export default component.exports